/* eslint-disable react-hooks/exhaustive-deps */
import useMyInfo from '@api/hooks/auth/useMyInfo';
import { getIsLoggedIn } from '@api/selectors/auth';
import useFetch from '@hooks/useFetch';

const useFeedBackChoices = (goalUID, options = { fallbackData: undefined }) => {
  const isLoggedIn = useMyInfo(getIsLoggedIn);
  const key = `v2/doubts/learner/feedback/?goal_uid=${goalUID}`;
  const { data, ...rest } = useFetch(
    isLoggedIn ? key : null,
    { useCamelCase: false },
    { fallbackData: options.fallbackData }
  );
  const { choices: feedbackChoices } = data || {};
  return {
    key,
    feedbackChoices,
    ...rest
  };
};

export default useFeedBackChoices;
